<template>
  <div class="to-quote-container">
    <el-table :data="requirementList"
              size="mini"
              style="width: 100%"
              height="100%">
      <el-table-column prop="itemName"
                       label="物料名称"
                       width="250">
      </el-table-column>
      <el-table-column prop="itemCode"
                       label="物料编码"> </el-table-column>
      <el-table-column prop="brandName"
                       label="品牌"> </el-table-column>
      <el-table-column prop="modelName"
                       label="机型"
                       width="150">
      </el-table-column>
      <el-table-column prop="moduleName"
                       label="模块"> </el-table-column>
      <el-table-column label="品项">
        <template slot-scope="scope">
          <el-tag :type="scope.row.qualityName | qualityType"
                  size="mini">
            {{ scope.row.qualityName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="quantity"
                       label="数量"> </el-table-column>
      <el-table-column prop="dueDate"
                       label="到期日"
                       width="180">
        <template slot-scope="scope">
          {{ scope.row.dueDate | date }}
        </template>
      </el-table-column>
      <el-table-column label="产品图片"
                       width="100">
        <template slot-scope="scope">
          <el-image :src="`http://www.spr-atm.com/Seller/ShowImage?code=${scope.row.itemCode}`"
                    :preview-src-list="previewFiles(scope.row.itemCode)"
                    style="width:40px; height:40px">
            <div slot="error"
                 class="image-slot">
              <img src="@images/watermark.jpg"
                   style="width: 40px; height: 40px;"
                   alt="" />
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span class="quote"
                @click="handleQuote(scope.row)">报价</span>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="报价"
               :visible.sync="quoteDialogVisible"
               :before-close="handleDialogClose"
               width="80%">
      <ul class="stock-property-wrapper">
        <li class="material-name">物料名称</li>
        <li class="material-code">物料编码</li>
        <li class="brand">品牌</li>
        <li class="model">机型</li>
        <li class="module">模块</li>
        <li class="quality">品项</li>
        <li class="quantity">数量</li>
        <li class="due-date">到期日</li>
      </ul>
      <ul class="order-item-wrapper"
          v-if="JSON.stringify(quoteItem) !== '{}'">
        <li class="material-name">{{ quoteItem.itemName }}</li>
        <li class="material-code">{{ quoteItem.itemCode }}</li>
        <li class="brand">{{ quoteItem.brandName }}</li>
        <li class="model">{{ quoteItem.modelName }}</li>
        <li class="module">{{ quoteItem.moduleName }}</li>
        <li class="quality">
          <el-select v-model="quoteItem.qualityId"
                     placeholder="请选择品项"
                     clearable
                     size="mini"
                     v-if="qualityList.length > 0">
            <el-option v-for="item in qualityList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </li>
        <li class="quantity">
          <el-input-number v-model="quoteItem.quantity"
                           :min="1"
                           :precision="0"
                           size="mini"
                           style="width: 100px"></el-input-number>
        </li>
        <li class="due-date">
          <el-date-picker v-model="quoteItem.dueDate"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          size="mini"
                          :picker-options="pickerOptions"
                          placeholder="选择过期日">
          </el-date-picker>
        </li>
      </ul>
      <div class="price-input">
        <span>单价</span>
        <el-input-number v-model="quoteItem.price"
                         :min="0"
                         :precision="2"
                         size="mini"
                         style="width: 120px"></el-input-number>
      </div>
      <div class="remark-wrapper">
        <span>备注</span>
        <el-input type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="请输入产品更多描述"
                  v-model="remark">
        </el-input>
      </div>
      <el-button type="primary"
                 size="mini"
                 @click="submitQuotation">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    requirementList: {
      type: Array,
      default: () => []
    },
    qualityList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      quoteItem: {},
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      quoteDialogVisible: false,
      remark: ''
    }
  },
  mounted () { },
  methods: {
    handleQuote (item) {
      this.quoteDialogVisible = true
      this.quoteItem = JSON.parse(JSON.stringify(item))
      this.quoteItem.dueDate = new Date(this.quoteItem.dueDate)
    },
    submitQuotation () {
      const dueDate = this.$moment(this.quoteItem.dueDate).format('YYYY-MM-DD HH:mm:ss')
      const params = {
        price: Number(this.quoteItem.price),
        quoteRemark: this.remark,
        quoteQuantity: Number(this.quoteItem.quantity),
        quoteQualityId: this.quoteItem.qualityId,
        dueDate: dueDate,
        id: this.quoteItem.id
      }
      this.$http
        .put('/api/services/inquiryApp/dIDetail/Quote', params)
        .then(res => {
          this.$message.success('提交报价成功！')
          this.quoteDialogVisible = false
          this.$emit('getRequirementList')
        })
        .catch(err => {
          this.$message.error('提交报价失败！')
        })
    },
    handleDialogClose (done) {
      this.quoteItem = {}
      this.remark = ''
      done()
    },
    previewFiles (itemCode) {
      let arr = []
      arr.push(`http://www.spr-atm.com/Seller/ShowImage?code=${itemCode}`)
      return arr
    }
  }
}
</script>
<style lang="less" scoped>
.to-quote-container {
  height: 100%;
  overflow: auto;
}

.quote {
  color: #027cff;
  cursor: pointer;
}
.stock-property-wrapper {
  height: 45px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  li {
    padding: 0 10px;
  }
}
.order-item-wrapper {
  height: 50px;
  border-bottom: 1px solid #ededed;
  display: flex;
  align-items: center;
  font-size: 12px;
  li {
    padding: 0 10px;
  }
  .operation {
    color: #027cff;
    cursor: pointer;
  }
}
.material-name {
  width: 20%;
}
.material-code {
  width: 10%;
}
.brand {
  width: 10%;
}
.model {
  width: 10%;
}
.module {
  width: 10%;
}
.quality {
  width: 12%;
  display: flex;
  align-items: center;
}

.quantity {
  width: 8%;
}
.due-date {
  width: 15%;
}
.operation {
  width: 10%;
  text-align: center;
}
.el-dialog {
  .quantity {
    width: 10%;
  }
  .price-input {
    margin-top: 20px;
    display: flex;
    align-items: center;
    span {
      white-space: nowrap;
      margin-right: 10px;
    }
    .el-input {
      width: 100px;
    }
  }
  .remark-wrapper {
    margin-top: 20px;
    display: flex;
    align-items: center;
    span {
      white-space: nowrap;
      margin-right: 10px;
    }
  }
  .el-button {
    margin-top: 20px;
    margin-left: 40px;
  }
}
</style>
